var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGotsGlobalOrganicTextileStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 351.2 239.2",
    style: {
      enableBackground: "new 0 0 351.2 239.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000090262524221566902660000000398358444948515983_);fill:#3C9736;}\r\n\t.st1{clip-path:url(#SVGID_00000016056698468611133650000017363035089653339069_);fill:#12100B;}\r\n\t.st2{clip-path:url(#SVGID_00000106149779145283918710000000800687757990102156_);fill:#12100B;}\r\n\t.st3{clip-path:url(#SVGID_00000076577202910916847190000013028563488639944578_);fill:#12100B;}\r\n\t.st4{clip-path:url(#SVGID_00000009557715412492089590000016838003640988363418_);fill:#12100B;}\r\n\t.st5{clip-path:url(#SVGID_00000007397295161796105440000012110321354403613104_);fill:#12100B;}\r\n\t.st6{clip-path:url(#SVGID_00000168821187030087415310000007177652846186699966_);fill:#12100B;}\r\n\t.st7{clip-path:url(#SVGID_00000183927798976945561290000008124955594149511845_);fill:#12100B;}\r\n\t.st8{clip-path:url(#SVGID_00000142870041419399352120000003434672870412218540_);fill:#12100B;}\r\n\t.st9{clip-path:url(#SVGID_00000068659166126543846290000002659574675032227227_);fill:#12100B;}\r\n\t.st10{clip-path:url(#SVGID_00000131326270846841326160000013708618383254704048_);fill:#12100B;}\r\n\t.st11{clip-path:url(#SVGID_00000134959803217980169550000012947516690141859998_);fill:#12100B;}\r\n\t.st12{clip-path:url(#SVGID_00000154383766658958737300000007000693004416438413_);fill:#12100B;}\r\n\t.st13{clip-path:url(#SVGID_00000030488924427820482320000008022075799648572826_);fill:#12100B;}\r\n\t.st14{clip-path:url(#SVGID_00000000189079568526380480000002332771159018766764_);fill:#12100B;}\r\n\t.st15{clip-path:url(#SVGID_00000005965850521350058260000017428337020106587781_);fill:#12100B;}\r\n\t.st16{clip-path:url(#SVGID_00000148646550689282532690000012218110216197362859_);fill:#12100B;}\r\n\t.st17{clip-path:url(#SVGID_00000042711345802802705710000007643796817654366893_);fill:#12100B;}\r\n\t.st18{clip-path:url(#SVGID_00000121966188780596524960000015651457561100208314_);fill:#12100B;}\r\n\t.st19{clip-path:url(#SVGID_00000050665482586932536510000006537096045051767450_);fill:#12100B;}\r\n\t.st20{clip-path:url(#SVGID_00000144322687617416700900000016197504407084494267_);fill:#12100B;}\r\n\t.st21{clip-path:url(#SVGID_00000034074611540176350960000006338923225018963122_);fill:#12100B;}\r\n\t.st22{clip-path:url(#SVGID_00000026157796464409417020000001644946502791210382_);fill:#12100B;}\r\n\t.st23{clip-path:url(#SVGID_00000101787560369453204700000000422785450566471599_);fill:#12100B;}\r\n\t.st24{clip-path:url(#SVGID_00000025439962676799544910000008828275826518925997_);fill:#12100B;}\r\n\t.st25{clip-path:url(#SVGID_00000169534484542687940750000015745440094547051695_);fill:#12100B;}\r\n\t.st26{clip-path:url(#SVGID_00000118383735801082887080000014528534335393402268_);fill:#12100B;}\r\n\t.st27{clip-path:url(#SVGID_00000163786966109089526110000007486718721016855485_);fill:#12100B;}\r\n\t.st28{clip-path:url(#SVGID_00000119821372079767071600000003906640718981466248_);fill:#12100B;}\r\n\t.st29{clip-path:url(#SVGID_00000164475333826568983470000010376159187157097357_);fill:#12100B;}\r\n\t.st30{clip-path:url(#SVGID_00000057110176571096542730000014506424455345876405_);fill:#12100B;}\r\n\t.st31{clip-path:url(#SVGID_00000013886314705787153340000008894100666683392686_);fill:#12100B;}\r\n\t.st32{clip-path:url(#SVGID_00000028326315827690166070000015939058630993677701_);fill:#12100B;}\r\n\t.st33{clip-path:url(#SVGID_00000054236358466994719930000011168891343993407124_);fill:#12100B;}\r\n\t.st34{clip-path:url(#SVGID_00000111151708046862870210000014307057471737309623_);fill:#12100B;}\r\n\t.st35{clip-path:url(#SVGID_00000100354018729190785320000000824987984978233266_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160188395647087539470000006879996506055007402_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160188395647087539470000006879996506055007402_)",
      fill: "#3C9736"
    },
    d: "M178.4,48 c-41.3,0-74.8,33.5-74.8,74.8s33.5,74.8,74.8,74.8s74.8-33.5,74.8-74.8C253.3,81.5,219.8,48,178.4,48"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069382285427694306360000005831223189508881566_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109730830620294175330000008351310996036587438_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069382285427694306360000005831223189508881566_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000109730830620294175330000008351310996036587438_)",
      fill: "#12100B"
    },
    d: "M124.9,190 c3.4,2.7,4.3,6.5,1.5,10c-2.6,3.4-6.9,3.4-10.1,0.9c-1.1-0.8-2.2-1.9-2.9-3l1.5-1.7c0.5,1.1,1.3,2,2.3,2.7c2.3,1.8,5,1.5,6.8-0.8 c1.7-2.1,1.9-4.6-0.4-6.4c-0.6-0.4-1.2-0.8-1.9-1l-1.8,2.3l1.4,1.1l-1.2,1.5l-3.5-2.7l4-5.1C122.2,188.2,123.6,189,124.9,190"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000191103184537373790000013017768041977343882_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160171707621828716400000006751426505289538729_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000191103184537373790000013017768041977343882_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160171707621828716400000006751426505289538729_)",
      fill: "#12100B"
    },
    points: "117,183.2  106.9,192.2 104.9,189.9 113.2,182.6 109.4,178.2 111.1,176.7  "
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132080027941863514590000002763418908237185719_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118364512421373121650000018178210613138685086_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132080027941863514590000002763418908237185719_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000118364512421373121650000018178210613138685086_)",
      fill: "#12100B"
    },
    d: "M106.1,168.9 c2.3,3.6,1.2,7-2.3,9.3c-3.5,2.2-7.1,1.7-9.4-1.9c-2.3-3.6-1.2-7.1,2.3-9.3S103.8,165.3,106.1,168.9 M96.1,175.2 c1.4,2.2,4.1,1.5,6,0.3c1.8-1.2,3.6-3.3,2.3-5.5c-1.4-2.3-4.1-1.5-6-0.4C96.5,170.9,94.7,173,96.1,175.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000117660937959298161420000002568346096729580478_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043455364097239356410000010791822692396491161_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117660937959298161420000002568346096729580478_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000043455364097239356410000010791822692396491161_)",
      fill: "#12100B"
    },
    d: "M98.7,154.9l1.8,4.6 l-12.5,5l-2-5.1c-0.8-2-0.9-4.4,1.4-5.4c1.6-0.6,3-0.1,3.9,1.3c-0.4-1.7,0.2-3.3,1.9-3.9C96.1,150.1,97.7,152.4,98.7,154.9  M88,159.5l0.6,1.6l3.6-1.4l-0.5-1.3c-0.5-1.2-1.4-2.3-2.8-1.7C87.5,157.1,87.6,158.4,88,159.5 M93.3,157.8l0.5,1.2l3.9-1.6 l-0.5-1.3c-0.5-1.3-1.5-2.6-3-2C92.5,154.8,92.8,156.4,93.3,157.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000028298813739596736720000002317790760858621370_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003811084522441772100000011253136975836374147_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028298813739596736720000002317790760858621370_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000003811084522441772100000011253136975836374147_)",
      fill: "#12100B"
    },
    d: "M93.6,136.3l-3.1,1.8 l1.1,5.6l3.5,0.5l0.6,2.9l-14.2-2.4l-0.8-3.8l12.2-7.7L93.6,136.3z M83,142.5l6.5,1l-0.9-4.4L83,142.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172421094301948463750000013759211254992289427_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071542543762460462770000002738774110248352433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172421094301948463750000013759211254992289427_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000071542543762460462770000002738774110248352433_)",
      fill: "#12100B"
    },
    points: "92.8,129.2  79.3,129.5 79.3,126.5 90.3,126.2 90.2,120.4 92.6,120.4  "
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000097462961123083726160000006641751903892122800_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093167893302383552490000015924675263478250159_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097462961123083726160000006641751903892122800_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000093167893302383552490000015924675263478250159_)",
      fill: "#12100B"
    },
    d: "M95.7,101.3 c-1.1,4.2-4.3,5.7-8.4,4.6c-4-1.1-6.1-4.1-5-8.2c1.1-4.2,4.3-5.7,8.4-4.6C94.7,94.2,96.8,97.2,95.7,101.3 M84.3,98.3 c-0.7,2.5,1.7,4,3.8,4.6s4.9,0.4,5.6-2.1c0.7-2.6-1.6-4-3.8-4.6C87.8,95.6,85,95.7,84.3,98.3"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000061449188260535550300000001367119336650925231_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183944088523434407670000003043935185409741712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061449188260535550300000001367119336650925231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000183944088523434407670000003043935185409741712_)",
      fill: "#12100B"
    },
    d: "M102.2,83.8l-4-0.5 c-1.4-0.1-1.9,0-2.5,1.3l-0.5,1l5,2.4l-1.3,2.6l-12.1-5.8l2.4-4.9c1-2.1,2.8-3.7,5.2-2.6c1.7,0.8,2.1,2.5,1.6,4.2 c0.7-1,1.5-1.2,2.7-1.1l4.9,0.4L102.2,83.8z M90.5,81.8l-0.6,1.3l3.5,1.7l0.6-1.2c0.6-1.2,0.8-2.7-0.6-3.4 C91.9,79.5,91.1,80.5,90.5,81.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070811391570701445350000011773081645814217600_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045587763025659593320000014294252983319573917_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070811391570701445350000011773081645814217600_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000045587763025659593320000014294252983319573917_)",
      fill: "#12100B"
    },
    d: "M109.8,72.2 c-2.5,3.5-6.3,4.5-9.9,1.9c-3.5-2.5-3.7-6.7-1.3-10.1c0.8-1.1,1.9-2.2,2.9-3l1.8,1.4c-1.1,0.5-1.9,1.4-2.6,2.4 c-1.7,2.4-1.4,5,1,6.8c2.2,1.6,4.7,1.7,6.4-0.6c0.4-0.6,0.8-1.2,1-1.9l-2.3-1.7l-1,1.4l-1.6-1.1l2.6-3.6l5.3,3.8 C111.5,69.4,110.8,70.8,109.8,72.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000107576041853178996850000000747844900725478532_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120519514047664522420000011436816928728139429_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107576041853178996850000000747844900725478532_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120519514047664522420000011436816928728139429_)",
      fill: "#12100B"
    },
    d: "M122.7,57.9l-3.2-1.6 l-4.1,3.9l1.4,3.3l-2.1,2l-5.5-13.4l2.9-2.7l13,6.3L122.7,57.9z M111.9,52.2l2.5,6.1l3.3-3.1L111.9,52.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172426541254794792030000004773781779894319008_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181789970244299002140000018234461394158450837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172426541254794792030000004773781779894319008_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000181789970244299002140000018234461394158450837_)",
      fill: "#12100B"
    },
    points: "134.6,49.5  124.6,42.8 130.4,52.1 128.1,53.5 121,42.1 124.7,39.8 134.8,46.5 129,37.2 131.2,35.8 138.3,47.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000055674663859723820900000018224271473819715509_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177476284964868713290000005276747540448911257_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055674663859723820900000018224271473819715509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000177476284964868713290000005276747540448911257_)",
      fill: "#12100B"
    },
    points: "143.5,44.9  138.2,32.5 140.9,31.4 146.2,43.7  "
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000927340199576008820000016007995206628677271_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076599048907586729180000015487989461850467259_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000927340199576008820000016007995206628677271_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000076599048907586729180000015487989461850467259_)",
      fill: "#12100B"
    },
    d: "M157.9,40.2 c-4.2,1.1-7.8-0.5-8.9-4.8c-1.1-4.1,1.3-7.6,5.3-8.6c1-0.3,2.3-0.4,3.4-0.4l0.5,2.2c-0.9-0.1-2,0-2.8,0.2c-2.8,0.8-4,3.1-3.3,5.8 c0.8,2.8,2.9,4.1,5.7,3.4c1-0.3,1.9-0.7,2.6-1.3l0.7,2.1C160.2,39.4,158.9,39.9,157.9,40.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000045602927014106106690000016800023276807433393_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129888771210705752650000003165302408790189446_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045602927014106106690000016800023276807433393_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000129888771210705752650000003165302408790189446_)",
      fill: "#12100B"
    },
    points: "181.9,26.5  181.7,37.5 178.7,37.5 178.9,26.4 174.7,26.3 174.8,23.9 186.2,24.2 186.1,26.6  "
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000180353027963352383540000003368631391935160705_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109021419016613236530000006709914528287098020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180353027963352383540000003368631391935160705_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000109021419016613236530000006709914528287098020_)",
      fill: "#12100B"
    },
    points: "189.8,38.1  192.3,24.9 200.9,26.5 200.5,28.5 194.8,27.5 194.1,30.9 199.6,31.9 199.3,33.9 193.8,32.9 193.1,36.6 199,37.7 198.7,39.7  "
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031202250979803344170000005327688154460343938_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040570320537972875870000006347399770508195493_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031202250979803344170000005327688154460343938_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000040570320537972875870000006347399770508195493_)",
      fill: "#12100B"
    },
    points: "211.2,43.9  209.9,37.6 204.8,41.5 201.7,40.4 208.8,35.5 206.9,28 210.1,29.1 211.3,34.8 215.8,31.3 218.8,32.4 212.4,36.9 214.5,45.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026128256399710901160000007397825098544372378_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181776611437700211550000009226822568328729521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026128256399710901160000007397825098544372378_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000181776611437700211550000009226822568328729521_)",
      fill: "#12100B"
    },
    points: "227.7,39.9  222.2,49.5 219.6,48 225.1,38.4 221.4,36.3 222.6,34.2 232.6,39.9 231.4,41.9  "
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132056544749484033260000008991435892483845280_",
    x: 159.7,
    y: 39.4,
    transform: "matrix(0.6053 -0.796 0.796 0.6053 -8.0062 260.7383)",
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038381008426112371180000008332886964384330165_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132056544749484033260000008991435892483845280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 227.7,
    y: 48,
    transform: "matrix(0.6053 -0.796 0.796 0.6053 53.0994 206.1612)",
    style: {
      clipPath: "url(#SVGID_00000038381008426112371180000008332886964384330165_)",
      fill: "#12100B"
    },
    width: 13.5,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030478946660556940910000006287891031684681624_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183942902551651353070000014899619510763268540_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030478946660556940910000006287891031684681624_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000183942902551651353070000014899619510763268540_)",
      fill: "#12100B"
    },
    points: "236.3,59.8  245.8,50.3 247.9,52.4 240.1,60.2 244.2,64.3 242.5,66  "
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069382726419314175180000014540209445464555706_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165934519913389295120000012535418846781266852_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069382726419314175180000014540209445464555706_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000165934519913389295120000012535418846781266852_)",
      fill: "#12100B"
    },
    points: "245,69  255.8,61 261,68 259.4,69.3 255.9,64.6 253,66.7 256.4,71.1 254.7,72.4 251.4,67.9 248.4,70.1 252,75 250.3,76.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013190045637257096390000000355457635110111919_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070808747191405424590000008743055506399684249_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013190045637257096390000000355457635110111919_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000070808747191405424590000008743055506399684249_)",
      fill: "#12100B"
    },
    d: "M258.4,92.8 c-0.5-1.3-0.8-2.7-0.9-4.1l2.2-0.7c-0.2,1.3,0.1,2.6,0.6,3.8c0.4,1.2,1.3,2.3,2.7,1.8c1-0.4,1-1.9,1-2.9l0.1-1.5 c0.1-1.7,0.6-3.2,2.3-3.8c2.7-1,4.7,1.5,5.5,3.8c0.4,1.1,0.7,2.2,0.8,3.3l-2.1,0.7c0-1-0.2-2.1-0.5-3.1c-0.4-1-1.2-2.4-2.5-1.9 c-0.9,0.3-0.9,1.6-0.9,2.5v1.6c0,1.9-0.4,3.5-2.4,4.2C261.4,97.4,259.3,95.3,258.4,92.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000122683915292273445760000015984565717670077062_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092432084965835919030000006636668291264586671_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122683915292273445760000015984565717670077062_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000092432084965835919030000006636668291264586671_)",
      fill: "#12100B"
    },
    points: "273.6,105.2  262.8,107.4 262.2,104.5 273,102.3 272.2,98.1 274.5,97.7 276.8,108.9 274.5,109.4  "
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021833057534594063650000015782851699027109287_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049927591685029283330000015742758085115373739_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021833057534594063650000015782851699027109287_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000049927591685029283330000015742758085115373739_)",
      fill: "#12100B"
    },
    d: "M264.3,124.4l3.3-1.3 l-0.2-5.7l-3.4-1.1l-0.1-2.9l13.6,4.7l0.1,3.9l-13.3,5.6L264.3,124.4z M275.7,120l-6.2-2.1l0.1,4.5L275.7,120z"
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000123402503478626164630000017084299141268601006_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004506463960721677750000000742316882510253981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123402503478626164630000017084299141268601006_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000004506463960721677750000000742316882510253981_)",
      fill: "#12100B"
    },
    points: "262.8,138.7  274.5,135.6 263.6,133.8 264.1,131.2 277.3,133.4 276.6,137.7 265,140.8 275.8,142.6 275.4,145.2 262.1,143  "
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039091482554898359210000016409661499515216777_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040560824280438888750000002115614054052986782_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039091482554898359210000016409661499515216777_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000040560824280438888750000002115614054052986782_)",
      fill: "#12100B"
    },
    d: "M259,152.7l1.6-4.2 l12.6,4.7l-1.8,4.7c-1.5,4.1-4.6,5.6-8.7,4C258.4,160.3,257.5,156.8,259,152.7 M269.7,156.7l0.6-1.5l-8.7-3.3l-0.4,1 c-1.1,2.9-0.2,4.9,2.7,6C266.4,159.9,268.7,159.4,269.7,156.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023997399937019906810000007679340312698786968_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120538128482317280070000016870582235269902003_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023997399937019906810000007679340312698786968_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120538128482317280070000016870582235269902003_)",
      fill: "#12100B"
    },
    d: "M249.8,171l3.5,0.7 l3-4.9L254,164l1.5-2.5l8.9,11.4l-2,3.4l-14.2-2.6L249.8,171z M261.8,173.5l-4.1-5.1l-2.3,3.8L261.8,173.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023279450442472266580000017821874348282273926_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134212133700825326050000013468622641728534439_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023279450442472266580000017821874348282273926_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000134212133700825326050000013468622641728534439_)",
      fill: "#12100B"
    },
    d: "M241,182l3.8,1.5 c1.3,0.5,1.8,0.6,2.8-0.5l0.7-0.8l-4.2-3.7l1.9-2.2l10.1,8.9l-3.6,4.1c-1.5,1.7-3.7,2.8-5.7,1.1c-1.4-1.2-1.3-3-0.4-4.5 c-1,0.7-1.8,0.7-2.9,0.3l-4.6-1.8L241,182z M251.8,187.1l0.9-1.1l-2.9-2.6l-0.9,1c-0.9,1-1.5,2.4-0.3,3.4 C249.7,189,250.8,188.2,251.8,187.1"
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000095325418119229006980000013587547327128733627_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010274022749496898620000017540960695083467924_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095325418119229006980000013587547327128733627_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000010274022749496898620000017540960695083467924_)",
      fill: "#12100B"
    },
    d: "M232.3,190l3.5-2.8 l8.3,10.6l-3.9,3.1c-3.4,2.7-6.8,2.4-9.6-1C227.9,196.2,228.9,192.7,232.3,190 M239.4,199l1.2-1l-5.8-7.3l-0.9,0.7 c-2.4,1.9-2.7,4.1-0.7,6.5C234.9,200,237.1,200.7,239.4,199"
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172418271843041776440000001636984153352735379_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013889185239546755760000004366104838212655279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172418271843041776440000001636984153352735379_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000013889185239546755760000004366104838212655279_)",
      fill: "#12100B"
    },
    d: "M155.3,219.4 c-4.2-1.1-6.6-4.2-5.5-8.6c1-4.2,4.9-6,8.9-5c1.3,0.3,2.8,0.9,3.9,1.6l-0.7,2.2c-0.9-0.8-2-1.3-3.2-1.6c-2.9-0.7-5.2,0.6-5.9,3.5 c-0.7,2.6,0.2,5,3,5.7c0.7,0.2,1.4,0.3,2.1,0.2l0.7-2.8l-1.7-0.4l0.5-1.9l4.3,1.1l-1.6,6.3C158.5,220,156.9,219.8,155.3,219.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000900973603311045620000009582312389036787343_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005249892447041734350000003112205142490840966_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000900973603311045620000009582312389036787343_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000005249892447041734350000003112205142490840966_)",
      fill: "#12100B"
    },
    d: "M172.1,221.9 c-4.3-0.3-6.4-3.1-6.1-7.3c0.3-4.1,2.8-6.7,7-6.5c4.3,0.3,6.4,3.1,6.1,7.3C178.8,219.5,176.3,222.2,172.1,221.9 M172.8,210.2 c-2.6-0.2-3.6,2.4-3.8,4.6c-0.1,2.2,0.6,4.9,3.1,5c2.7,0.2,3.6-2.4,3.8-4.6C176.1,213,175.5,210.4,172.8,210.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002369122778633505060000008745914981355039111_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039117888192120175630000015118316735593446568_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002369122778633505060000008745914981355039111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000039117888192120175630000015118316735593446568_)",
      fill: "#12100B"
    },
    points: "188.9,210.6  190,221.6 187,221.9 185.9,210.9 181.7,211.3 181.5,209 192.8,207.8 193.1,210.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000028314228000186142960000005646572887993015196_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089549390457911448560000010429126934108412095_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028314228000186142960000005646572887993015196_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000089549390457911448560000010429126934108412095_)",
      fill: "#12100B"
    },
    d: "M203.2,219.4 c-1.3,0.3-2.7,0.5-4,0.5l-0.5-2.2c1.3,0.3,2.5,0.2,3.8-0.2c1.2-0.3,2.3-1.1,2-2.4c-0.3-1-1.7-1.1-2.8-1.3l-1.4-0.2 c-1.7-0.2-3-0.9-3.5-2.6c-0.7-2.8,1.9-4.4,4.2-5c1.1-0.3,2.2-0.5,3.3-0.4l0.5,2.1c-1-0.1-2.1,0-3.1,0.2c-1,0.3-2.4,1-2.1,2.2 c0.2,0.9,1.5,1.1,2.4,1.2l1.5,0.2c1.8,0.2,3.3,0.8,3.8,2.8C207.9,217,205.7,218.8,203.2,219.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177442265814078660050000004098029125181930387_",
    x: -20,
    y: 34.8,
    transform: "matrix(0.427 -0.9043 0.9043 0.427 -75.5581 148.3209)",
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178885351570511982590000005497794229453587874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177442265814078660050000004098029125181930387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.1,
    y: 205.1,
    transform: "matrix(0.427 -0.9043 0.9043 0.427 -108.0564 242.7115)",
    style: {
      clipPath: "url(#SVGID_00000178885351570511982590000005497794229453587874_)",
      fill: "#12100B"
    },
    width: 2.8,
    height: 3.1
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000086679952968864826710000010136362692495281847_",
    x: 47.6,
    y: 48.9,
    transform: "matrix(0.9057 -0.4239 0.4239 0.9057 -48.8508 76.1687)",
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011710275922591752890000012991500478841581242_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086679952968864826710000010136362692495281847_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 205.3,
    transform: "matrix(0.9057 -0.4239 0.4239 0.9057 -66.978 112.2623)",
    style: {
      clipPath: "url(#SVGID_00000011710275922591752890000012991500478841581242_)",
      fill: "#12100B"
    },
    width: 3.1,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000156552506495445865560000002135665075443984024_",
    x: 79.3,
    y: 23.9,
    width: 198.4,
    height: 198
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137845774708616350560000017468260214942862468_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156552506495445865560000002135665075443984024_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137845774708616350560000017468260214942862468_)",
      fill: "#FFFFFF"
    },
    d: "M116.4,116.6 l18.1,18.1l16.9-16.9v53.7h25.7V92.7l-18.5-18.4L116.4,116.6z M198.3,74.3L180,92.6v78.9h25.7v-53.7l16.8,16.8l18.1-18.1 L198.3,74.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotsGlobalOrganicTextileStandard);
export default __webpack_public_path__ + "static/media/GOTS_Global Organic_Textile_Standard.1257f24a6c74029ebf56c0dac071447b.svg";
export { ForwardRef as ReactComponent };